// src/lib/profile.ts
import { isIsoDate } from "@/lib/time/dates";
import type { ProfileRole, ProfileTag } from "@/schemas/profile";

const START_DATE = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC",
});

/** "Sep 25, 2022" from the warehouse's YYYY-MM-DD, read as that calendar date (UTC). */
export function formatStartDate(date: string | null): string | null {
  if (!date || !isIsoDate(date)) return null;
  return START_DATE.format(new Date(`${date}T00:00:00Z`));
}

/** "Sales Engineer, Senior (primary)". */
export function roleLabel(role: ProfileRole): string {
  const base = role.level ? `${role.role}, ${role.level}` : role.role;
  return role.isPrimary ? `${base} (primary)` : base;
}

/** "REST API (Submitted)"; an approved tag is just its name. */
export function tagLabel(tag: ProfileTag): string {
  return tag.status && tag.status !== "Approved" ? `${tag.tag} (${tag.status})` : tag.tag;
}
